import Analytics from '~/components/maud/analytics';

const AnalyticsPage = () => <Analytics />;

export default AnalyticsPage;
